import { NgModule } from '@angular/core';
import { MsOverlayPanelComponent } from './ms-overlay-panel.component';
import { SharedLibsModule } from 'app/shared/shared-libs.module';

@NgModule({
	declarations: [MsOverlayPanelComponent],
	imports: [SharedLibsModule],
	exports: [MsOverlayPanelComponent],
	providers: [],
})
export class MsOverlayPanelModule {}
